import {Model, View} from 'backbone';
import template from 'common-views/modal-data-sources.ejs';
import BaseTableView from 'properties/BaseTableView.js'
import SelectFormOrReportModal from 'common-views/SelectFormOrReportModalView.js'
import MainFormulaModal from 'common-views/ReportFilterFormulaModalView'
import RestService from 'RestService.js';
import formulaService from 'xml/FormulaService.js';
import util from 'util/Util.js';
import constants from 'Constants.js';
import Spinner from 'spin/spin';
import $ from 'jquery';
import listService from 'ListService';

class DataSourcesModalView extends View {
    initialize(opts) {
        super.initialize(opts);
        $('body').append(this.$el);
        this.gridEl = constants.PROP_MAIN_TABLE_MODAL;
        this.events = {};
        this.spinner = opts.spinner || new Spinner();
        // Filling table in case that dataSource data is already stored (Edit Mode).
        this.currentDataSource = this.model.get('dataSourceData');

        this.model.set({
            colModel: [
                {
                    name: 'id',
                    index: 'id',
                    key: true,
                    editable: false,
                    hidden: true
                },
                {
                    name: 'name',
                    index: 'name',
                    editable: false
                },
                {
                    name: 'displayName',
                    index: 'displayName',
                    editable: true
                }
            ],
            colNames: ['Id', 'Name', 'Display Name']
        });
        this.listenTo(this.model, 'change', this.render);
        this.onResize();
    }

    setRow(rowid){
        this.model.set({
            rowid: rowid
        }, {silent: true});
    }
    
    onCellSelect(rowid, iCol, cellcontent,e){
        return;
    }

    onSelectRow(rowId, status,e){
        return;
    }

    onDoubleClickRow(rowId,iRow,iCol,e){
        return;
    }    

    // Listening on the resize event of the window to call the resizeGrid method on the parent an adapt the grid.
    onResize() {
        $(window).on('resize', () => {
            this.resizeGrid();
            util.makePanelFit();
        })
    }

    // Passing the isEdit Flag in order to select the already chosen rows stored in the model on load.
    getReportFields(formGUID, isEdit) {
        // Calling the report fields.
        this.showSpinner(true);
        RestService.getReportFields(formGUID).then((reportData)=> {
            let reportFields;
            let self = this;
            let prevFields = [];
            if (reportData.RESULT.RESPONSE.Fields.Field) {
                if (isEdit) {
                    prevFields = this.currentDataSource.Fields.Field;
                }
                this.currentDataSource.Fields.Field = [];

                util.deleteGridRows(this.gridEl);
                reportFields = reportData.RESULT.RESPONSE.Fields.Field instanceof Array
                    ? reportData.RESULT.RESPONSE.Fields.Field
                    : [reportData.Fields.Field];
                let fieldsArray = [];
                reportFields.forEach((field, index)=> {
                    this.currentDataSource.Fields.Field.push(_.merge( util._unPrefixAmp( field ), {inUse: false, displayName: ''}) );
                });

                self.enableSaving();
                let previouslySelectedFields = prevFields.filter((v) => util.isTrue(v.inUse));
                if (isEdit) {
                    // Update the new fields with the old selected and displayName values.                    
                    _.forEach(previouslySelectedFields, (field, index) => {
                        let result = this.currentDataSource.Fields.Field.filter((v) => v.id === field.id );
                        // PF-4502: Making sure we have something to show
                        if (result.length) {
                            result[0].inUse = 'true';
                            result[0].displayName = field.displayName;
                        }
                    });
                }
                this.currentDataSource.Fields.Field.forEach((field, index)=> {
                    fieldsArray.push({ id: field.id, name: this.changeName(field.name), displayName: field.displayName });
                });
                $(this.gridEl).jqGrid('setGridParam', { data: fieldsArray }).trigger('reloadGrid');
                this.selectRowsByModelIds(previouslySelectedFields.map(a => a.id));
                this.showSpinner(false);
            }
        }).catch(err => { this.showSpinner(false); console.log(err); });
    }

    changeName(name){

        let newName='';
        if(!name){
            return name;
        }
        switch (name.toLowerCase()){
            case 'instanceguid':
                newName='Meta - Instance ID';
                break;
            case 'parentguid':
                newName='Meta - Parent Instance ID';
                break;
            case 'linkid':
                newName='Meta - Link';
                break;
            case 'stagename':
                newName='Meta - Stage';
                break;
            case 'lastdate':
                newName='Meta - Last Submission Date';
                break;
            case 'instancenumber':
                newName='Meta - Instance Number';
                break;
            case 'instancename':
                newName='Meta - Instance Name';
                break;
            case 'versionmajor':
                newName='Meta - Version Major';
                break;
            case 'versionminor':
                newName='Meta - Version Minor';
                break;

            default:
                newName=name.replace('|',' - ');
                break;
        }
        return newName;
    }




    selectForm() {

        var sfModal = new SelectFormOrReportModal({
            model: new Model(),
            mode: 'form',
            checkForInstances: false,
            publishedInstances:true
        });
        sfModal.render().then((selectedFormOrReport)=> {
            // Grabbing the chosen report form data.
            console.log("Returned Form Data", selectedFormOrReport);

            this.currentDataSource.name = selectedFormOrReport.name;
            this.currentDataSource.formName = selectedFormOrReport.name;
            this.currentDataSource.formGUID = selectedFormOrReport.GUID;
            this.currentDataSource.uses=0;

            $("input[name='formName']").val(selectedFormOrReport.name);
            $("input[name='dataSourceName']").val(selectedFormOrReport.name);
            this.getReportFields(selectedFormOrReport.GUID, false);
        });
    }

    editFilter(ev) {    
        // Checking for emptyness.
        let currentFormulaParameter = this.model.get('dataSourceData').formulaParameter;
        let formulaParameter = $.isEmptyObject(currentFormulaParameter) ? undefined : currentFormulaParameter;
     
        let dataSource = [];
        if(this.currentDataSource.Fields.Field.length > 0){
            this.setSelectedFieldsInModel();
            dataSource = this.currentDataSource.Fields;
        }

        const attributes = {
                    formulaParameter: formulaParameter,
                    type: 'DataSource',
                    dataSource: dataSource
        };
        // Calling modal and saving the formula parameter on model.
        var sfModal = new MainFormulaModal({model: new Model(attributes)});
        sfModal.render().then((formulaParameter)=> {
            let dataSourceData = this.model.get('dataSourceData');
            dataSourceData.formulaParameter = formulaParameter;      
            this.model.set('dataSourceData', dataSourceData, {silent: true});
            this.renderFormulaAndFilters();
        }).catch(err => console.log(err));
    }

    clearFilter(e) {
        let dataSourceData = this.model.get('dataSourceData');
        dataSourceData.formulaParameter = "";
        this.model.set('dataSourceData', dataSourceData, {silent: true});
        this.renderFormulaAndFilters();
    }

    afterSaveCell(rowid, cellname, value) {

        let currentGrid = $(this.gridEl);
        const rowFieldId = currentGrid.jqGrid('getRowData', rowid).id;
        let field = $.grep(this.currentDataSource.Fields.Field, function(e){ return e.id === rowFieldId; });
        field[0].displayName = value;
    }
    afterEditCell(rowId, cellName, value, iRow, iCol){
        let self=this;
        $("#"+iRow+"_"+cellName).on('blur',function(){
            $(self.gridEl).saveCell(iRow,iCol);
        });
    }



    changeFormName(ev) {
        this.currentDataSource.name = ev.currentTarget.value;
    }

    changeJoinFilter(ev) {
        this.currentDataSource.useORForDynamicFilters = (ev.currentTarget.value === 'or') ? true : false;
    }

    changeNotes(ev) {
        this.currentDataSource.description = ev.currentTarget.value;
    }

    selectAllFormFields(ev) {
        console.log('selecting all');
        let formFieldsGrid = $(this.gridEl);

        this.clearAllFormFields();
        var ids = formFieldsGrid.getDataIDs();
        console.log('Los ids', ids);
        for (var i = 0, il = ids.length; i < il; i++) {
            formFieldsGrid.jqGrid('setSelection', ids[i], true);
        }
    }

    selectRowsByModelIds(ids) {
        let formFieldsGrid = $(this.gridEl);
        const rowsData = formFieldsGrid.jqGrid('getGridParam', 'data');
        $.each(rowsData, (idx, rowData) => {
            if (ids.indexOf(rowData.id) > -1) {
                formFieldsGrid.jqGrid('setSelection', rowData.id, true);
            }
        });
    }


    clearAllFormFields() {
        let formFieldsGrid = $(this.gridEl);
        formFieldsGrid.jqGrid('resetSelection');
    }

    refresh(ev) {
        console.log('Refreshing...');
        if(this.currentDataSource.formGUID) {
            this.setSelectedFieldsInModel();
            $(this.gridEl).jqGrid('clearGridData');
            this.getReportFields(this.currentDataSource.formGUID, true);
        }
    }

    showSpinner(show){
        if (show){
            this.spinner.spin($(constants.CONTENT_ID).get(0));
        }else if (this.spinner){
            this.spinner.stop();
        }
    }

    renderGrid() {
        //let formFields = this.model.get('dataSourceData').formFields;
        util.deleteGridRows(this.gridEl);
        let self = this;
        let gridObject = util.getGridObject(this, {multiselect: true, shrinkToFit:true, maxHeight:135, deselectAfterSort: false, autowidth: true});
        let grid = $(this.gridEl).jqGrid(gridObject);

        if (this.currentDataSource.Fields.Field.length !== 0) {
            let valArray = [];
            $.each(this.currentDataSource.Fields.Field, (index, field) => {
                valArray.push({ id: field['id'], name: this.changeName(field['name']), displayName: field['displayName'] });
            });
            /*_.forEach(this.currentDataSource.Fields.Field, (field, index) => {
                //self.fillNewRow(index, field['id'], this.changeName(field['name']), field['displayName'])
                valArray.push({ id: field['id'], name: this.changeName(field['name']), displayName: field['displayName'] });
            });*/
            grid.jqGrid('setGridParam', { data: valArray }).trigger('reloadGrid');
            let previouslySelectedFields = this.currentDataSource.Fields.Field.filter((v) => util.isTrue(v.inUse));
            this.selectRowsByModelIds(previouslySelectedFields.map(a => a.id));
        } else {
            for (let i = 0; i < 6; i++) {
                self.fillNewRow(i, '', '', '');
            }
        }

        this.resizeGrid();
        this.delegateEvents();
        this.$el.css('cursor', 'default');
    }

    resizeGrid(){
        let grid = $('.ui-jqgrid-btable');
        if (grid) {
            grid.each(function(index) {
                let gridId = $(this).attr('id');
                let gridParentWidth = $('#gbox_' + gridId).parent().width();
                $('#' + gridId).setGridWidth(gridParentWidth);
            });
        }
    }

    getFormulaText(args, text){
        let newText = text;
        _.forEach(args, (arg) =>{            
            if(arg.children){
                newText = newText  + "(";
                newText = this.getFormulaText(arg.children,newText)  + ")";
            }
            else{
                if(arg.kind === "function"){
                    newText = newText + " " + formulaService.getFunctionName(arg.type, true);
                    newText = this.getFormulaText(arg.functionParameters, newText);
                }
                else{
                    newText = arg.caption ? newText + " " + arg.caption : newText + " " + arg.value;
                }
            }
        });
        return newText;
    }

    renderFormulaAndFilters() {
        let useORForDynamicFilters = util.isTrue( this.currentDataSource.useORForDynamicFilters );
        const filterCond = useORForDynamicFilters ? 'or' : 'and';
        $(':radio[value="' + filterCond + '"]').prop('checked', true);
        let formulaValue = "";
        if(!$.isEmptyObject(this.model.get('dataSourceData').formulaParameter)){
            let ds = this.model.get('dataSourceData');
            formulaValue = this.getFormulaText(ds.formulaParameter.arguments, "")
        }
        console.log('Formula Value', formulaValue);
        $("#staticFilter").prop("value", formulaValue);

        // Enable/Disable clear button
        if (formulaValue === '') {
            $('#clearFilter').prop('disabled', true);
        }
        else {
            $('#clearFilter').removeAttr("disabled");
        }
    }

    fillNewRow(index, id, name, displayName) {
        $(this.gridEl).addRowData(index, {id, name, displayName});
    }

    setSelectedFieldsInModel() {

        // Getting all the selected rows only.
        let currentGrid = $(this.gridEl);
        let allRows = currentGrid.jqGrid('getGridParam', 'selarrrow');

        // Cleaning previous fields if any.
        _.forEach(this.currentDataSource.Fields.Field, (field) => {
           field.inUse = false;
        });

        // Filling the model with the data contained in the selected rows.
        allRows.forEach((id)=> {
            //console.log("ID", id);

            // Saving row data first and changing the focus on the initial row to remove edit cell mode.
            currentGrid.jqGrid('saveRow', id, false);
            currentGrid.jqGrid("editCell", 0, 0, false);

            const rowFieldId = currentGrid.jqGrid('getRowData', id).id;

            // find Field in DataSource Structure and update the inUse and displayName
            let field = $.grep(this.currentDataSource.Fields.Field, function(e){ return e.id === rowFieldId; });
            field[0].inUse = true;

        });
        
        // Adding the new table values to the model.
        //this.model.set('dataSourceData', currentDataSource, {silent: true});
    }

    renderDialog(resolve, reject) {
        listService.isUndoRedoEnabled = false;
        $(constants.DIALOG_ID).dialog({
            dialogClass: "no-close",
            autoOpen: true,
            height: 600,
            width: 620,
            modal: true,
            resizable: true,
            buttons: [
                {
                    id: 'dialogOk',
                    text: 'OK',
                    'class': 'btn-select-item',
                    disabled: true,
                    click: () => {
                        this.setSelectedFieldsInModel();
                        resolve(this.currentDataSource);
                        this.closeModal();
                    }
                },
                {
                    id: 'dialogCancel',
                    'text': 'Cancel',
                    click: () => {
                        resolve("Canceled");
                        this.closeModal();
                    }
                }
            ],
            open: () => {
                this.bindEvents();
                $( constants.DIALOG_ID ).closest('div.ui-dialog').append('<img id="modalResizeHandler" src="'+require("common/buttons/resize_handler.png")+'"/>');
            },
            close: () => {
                this.unbindEvents();
            }
        });

        $('div[role="dialog"]').draggable(constants.DEFAULT_DRAGGABLE_OPTIONS);
    }

    render() {
        return new Promise((resolve, reject) => {            
            this.showSpinner(true);
            window.setTimeout(() => {
                this.$el.html(template(this.model.toJSON()));
                // Rendering the join filter option  from the radio button.
                this.renderFormulaAndFilters();
                this.renderDialog(resolve, reject);
                this.renderGrid();
                this.enableSaving();            
                this.showSpinner(false);
            }, 10);
        });
    }

    enableSaving() {
        if ($(this.gridEl).jqGrid('getGridParam', 'reccount') > 0) {
            $("#dialogOk").button("option", "disabled", false);
        }
    }

    bindEvents() {
        $('#dialog').find('.item').on("click", e => this.itemSelected(e));
        $('button#selectForm').on("click", e=>this.selectForm(e));
        $('#dataSourceName').on("change", e=>this.changeFormName(e));
        $('#selectAll').on("click", e=>this.selectAllFormFields(e));
        $('#clearAll').on("click", e=>this.clearAllFormFields(e));
        $('#refresh').on("click", e=>this.refresh(e));
        $('#editFilter').on("click", e=>this.editFilter(e));
        $('#clearFilter').on("click", e => this.clearFilter(e));
        $('input[name="joinFilter"]').on("click", e=>this.changeJoinFilter(e));
        $('#notes').on("change", e=>this.changeNotes(e));

    }

    unbindEvents() {
        $('#dialog').find('.item').off();
        $('button#selectForm').off();
         $(window).off('resize');
    }

    closeModal() {
        listService.isUndoRedoEnabled = true;
        $(constants.DIALOG_ID).dialog("destroy");
        this.remove();
    }

}

export default DataSourcesModalView;